import { Link } from 'react-router-dom';
import type { DuplicateCultivar } from '../../utils/cultivarDuplicate';

// Shown in place of a save error when the organisation already has the
// cultivar (utils/cultivarDuplicate).
export default function DuplicateCultivarNotice({ existing }: { existing: DuplicateCultivar }) {
  return (
    <div className="mb-6 rounded-lg border border-warning-200 bg-warning-50 p-4" role="alert">
      <p className="text-warning-800">
        Your organisation already has <span className="font-semibold">{existing.name}</span> for this crop.{' '}
        <Link to={`/cultivar/${existing.id}`} className="font-medium underline">
          Open {existing.name}
        </Link>
      </p>
    </div>
  );
}
